import BaseApiClient from "@/api/base-client";
class IntercomApi extends BaseApiClient {
    getToken = async () => {
        return this.get("/api/intercom/token");
    };
    static instance = new IntercomApi();
}
export default IntercomApi.instance;
